import { AppServices } from '@singularsystems/neo-core';
import { Config } from '../Models/Config/Config';
import { AppDataService } from '../Services/AppDataService';
import { RouteService } from '../Services/RouteService';
import { IAppLayout } from '../Services/AppLayout';
import { CommonTypes } from 'st-common/App/CommonTypes';

const SharedTypes = {
    Services: {
        ...CommonTypes.Services,
        AppDataCache: new AppServices.ServiceIdentifier<AppDataService>("Services.AppDataCache"),
        RouteService: new AppServices.ServiceIdentifier<RouteService>("Shared.Services.RouteService"),
        AppLayout: CommonTypes.Services.AppLayout.asType<IAppLayout>(),
    },
    Config: CommonTypes.Config.asType<Config>(),
};

export default SharedTypes;